import brushOxford1 from 'ui/images/brush-oxford-1.png'
import brushOxford2 from 'ui/images/brush-oxford-2.png'
import brushOxford3 from 'ui/images/brush-oxford-3.png'
import brushOrange1 from 'ui/images/brush-orange-1.png'
import brushOrange2 from 'ui/images/brush-orange-2.png'
import brushOrange3 from 'ui/images/brush-orange-3.png'
import brushRed1 from 'ui/images/brush-red-1.png'
import brushRed2 from 'ui/images/brush-red-2.png'
import brushRed3 from 'ui/images/brush-red-3.png'
import brushPurple1 from 'ui/images/brush-purple-1.png'
import brushPurple2 from 'ui/images/brush-purple-2.png'
import brushPurple3 from 'ui/images/brush-purple-3.png'
import brushParadiso1 from 'ui/images/brush-paradiso-1.png'
import brushParadiso2 from 'ui/images/brush-paradiso-2.png'
import brushParadiso3 from 'ui/images/brush-paradiso-3.png'
import brushShadowGreen1 from 'ui/images/brush-shadowgreen-1.png'
import brushShadowGreen2 from 'ui/images/brush-shadowgreen-2.png'
import brushShadowGreen3 from 'ui/images/brush-shadowgreen-3.png'

export default {
  displayFont: '"Hill", sans-serif',
  bodyFont: '"Oxygen", Helvetica, sans-serif',
  colors: {
    grey: {
      lightest : '#FFFFFF',
      lighter  : '#F0F0F0',
      light    : '#E1E1E1',
      base     : '#C8C8C8',
      dark     : '#969696',
      darker   : '#646464',
      darkest  : '#4B4B4B'
    },
    oxford: {
      light  : '#4B5F69',
      base   : '#324650',
      dark   : '#192D37',
      brush1 : brushOxford1,
      brush2 : brushOxford2,
      brush3 : brushOxford3,
    },
    pacific: {
      light  : '#23C8D2',
      base   : '#0AAFB9',
      dark   : '#0096A0',
    },
    orange: {
      light  : '#FFAA1E',
      base   : '#F59100',
      dark   : '#DC7800',
      brush1 : brushOrange1,
      brush2 : brushOrange2,
      brush3 : brushOrange3,
    },
    red: {
      light  : '#FF6437',
      base   : '#E6461E',
      dark   : '#CD3205',
      brush1 : brushRed1,
      brush2 : brushRed2,
      brush3 : brushRed3,
    },
    purple: {
      light  : '#9669C8',
      base   : '#7D50AA',
      dark   : '#643796',
      brush1 : brushPurple1,
      brush2 : brushPurple2,
      brush3 : brushPurple3,
    },
    paradiso: {
      light  : '#46919B',
      base   : '#2D7882',
      dark   : '#195F69',
      brush1 : brushParadiso1,
      brush2 : brushParadiso2,
      brush3 : brushParadiso3,
    },
    shadowgreen: {
      light  : '#AFDCDC',
      base   : '#96C3C3',
      dark   : '#7DAAAA',
      brush1 : brushShadowGreen1,
      brush2 : brushShadowGreen2,
      brush3 : brushShadowGreen3,
    }
  },
  navHeight: 80,
  grid: {
    breakpoints: { // defaults below
      giant: 1200,
      xl: 1200,
      desktop: 992,
      lg: 992,
      tablet: 768,
      md: 768,
      phone: 576,
      sm: 576,
      smaller: 575,
      xs: 575,
    },
    row: {
      padding: 10, // default 15
    },
    col: {
      padding: 10, // default 15
    },
    container: {
      padding: 50, // default 15
    }
  }
};



// WEBPACK FOOTER //
// ./src/ui/styles/theme.js